import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import PlaceRecommends from './components/PlaceRecommends'
import { getRecommendList } from '@app-core/place/actions'

class PlaceRecommendsContainer extends PureComponent {
  componentDidMount() {
    this._getRecommendList()
  }

  componentDidUpdate(prevProps) {
    const { loc: prevLoc, placeId: prevPlaceId } = prevProps
    const { loc, placeId } = this.props
    const isLocUpdated =
      prevLoc.get('lat') !== loc.get('lat') || prevLoc.get('lng') !== loc.get('lng')
    const isPlaceIdChanged = prevPlaceId !== placeId
    if (isLocUpdated || isPlaceIdChanged) {
      this._getRecommendList()
    }
  }

  _getRecommendList = () => {
    const { loc, placeId, isRecommendListLoading } = this.props
    if (isRecommendListLoading) return

    this.props.getRecommendList({
      placeId,
      lat: loc.get('lat'),
      lng: loc.get('lng'),
    })
  }

  render() {
    const { recommendPlaceIds } = this.props
    return <PlaceRecommends recommendPlaceIds={recommendPlaceIds.toJS()} />
  }
}

function mapStateToProps(state) {
  return {
    loc: state.currentUser.get('userLocation'),
    recommendPlaceIds: state.place.get('recommendPlaceIds'),
    isRecommendListLoading: state.place.get('isRecommendListLoading'),
  }
}

export default connect(mapStateToProps, {
  getRecommendList,
})(PlaceRecommendsContainer)
